export default function modals() {
    const open_request_form = document.querySelectorAll('[data-target="open_request_form"]');
    const request_form = document.getElementById('request_form');
    const success_modal = document.getElementById('success_modal');
    const submit_button = document.getElementById('send-request');

    if (!open_request_form || !request_form) {
        return;
    }

    open_request_form.forEach(element => {
        element.addEventListener('click', () => {

            const form = request_form.querySelector('form');
            const existingCommentInput = form.querySelector('input[name="comment"]');
            if (existingCommentInput) {
                existingCommentInput.remove();
            }

            if (element.classList.contains('tariff-order-button')) {
                const tariffTitle = element.dataset.tariffTitle;
                const pageUrl = window.location.href;
                const comment = `Тариф: ${tariffTitle}, Сторінка: ${pageUrl}`;

                const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = 'comment';
                hiddenInput.value = comment;
                form.appendChild(hiddenInput);
            }

            const caseHero = document.querySelector('[data-case-title]');
            if (caseHero && !form.querySelector('input[name="comment"]')) {
                const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = 'comment';
                hiddenInput.value = `Кейс: ${caseHero.dataset.caseTitle}, Сторінка: ${window.location.href}`;
                form.appendChild(hiddenInput);
            }

            if (window.clarity) {
                window.clarity('event', 'open_request_form');
            }

            request_form.classList.add('open');
        })
    });

    Array.from(document.getElementsByClassName('close_modal')).forEach(element => {
        element.addEventListener('click', (e) => {
            request_form.classList.remove('open');
            success_modal.classList.remove('open');

            removeCommentInput();
        });
    });

    submit_button.addEventListener('click', (e) => {
        e.preventDefault();

        const form = e.target.closest('form');
        const name = form.querySelector('input[name="name"]').value;
        const phone = form.querySelector('input[name="phone"]').value;
        const commentElement = form.querySelector('input[name="comment"]');
        const comment = commentElement ? commentElement.value : '';

        document.querySelector('input[name="name"]').parentElement.classList.remove('error');
        document.querySelector('input[name="phone"]').parentElement.classList.remove('error');

        if (!name || !phone) {
            if (!name) {
                document.querySelector('input[name="name"]').parentElement.classList.add('error');
            }
            if (!phone) {
                document.querySelector('input[name="phone"]').parentElement.classList.add('error');
            }

            return;
        }

        fetch('/post-feedback', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                name: name,
                phone: phone,
                comment: comment
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.result && response.result.length > 0) {
                    // Handle validation errors.
                    response.result.forEach(error => {
                        const input = document.querySelector(`input[name="${error.field}"]`);
                        if (input) {
                            input.parentElement.classList.add('error');
                        }
                    });
                } else {
                    form.querySelector('input[name="name"]').value = '';
                    form.querySelector('input[name="phone"]').value = '';

                    request_form.classList.remove('open');
                    success_modal.classList.add('open');
                    removeCommentInput();
                    setTimeout(() => {
                        success_modal.classList.remove('open');
                    }, 3000);
                }
            });
    });

    function removeCommentInput() {
        const form = request_form.querySelector('form');
        if (form) {
            const existingCommentInput = form.querySelector('input[name="comment"]');
            if (existingCommentInput) {
                existingCommentInput.remove();
            }
        }
    }

}
